// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__EnniJ","edit":"styles_edit__SGDsh","delete":"styles_delete__Ww0Za","table_container":"styles_table_container__pzkn9","bannerIcon":"styles_bannerIcon__5dkkK"};